import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';

@Injectable()
export class ManageGroupSelectionService {
  selection = new SelectionModel<number>(true);
  indeterminate = new SelectionModel<number>(true);
  initSelection = new SelectionModel<number>(true);
  initIndeterminate = new SelectionModel<number>(true);

  updateSelection(groupIds: number[], indeterminate: number[]) {
    this.selection.clear();
    this.indeterminate.clear();
    this.initSelection.clear();
    this.initIndeterminate.clear();
    this.selection.select(...groupIds);
    this.initSelection.select(...groupIds);
    this.indeterminate.select(...indeterminate);
    this.initIndeterminate.select(...indeterminate);
  }

  toggleCheckbox(id: number) {
    this.selection.toggle(id);
    this.indeterminate.deselect(id);
  }

  deselectAll() {
    this.selection.clear();
    this.indeterminate.clear();
  }

  isSelected(id: number): boolean {
    return this.selection.isSelected(id);
  }

  isIndeterminate(id: number): boolean {
    return this.indeterminate.isSelected(id);
  }

  isChecklistUpdated() {
    if (
      this.initSelection.selected.length !== this.selection.selected.length ||
      this.initIndeterminate.selected.length !== this.indeterminate.selected.length
    )
      return true;
    if (this.getDeleted().length > 0) return true;
    return this.getAdded().length > 0;
  }

  getDeleted(): number[] {
    return this.initSelection.selected.filter((id) => !this.selection.isSelected(id));
  }

  getAdded(): number[] {
    return this.selection.selected.filter(
      (id) =>
        !this.initSelection.isSelected(id) ||
        (this.initIndeterminate.isSelected(id) && !this.indeterminate.isSelected(id)),
    );
  }
}
